import React from 'react';
import ReactDOM from 'react-dom';
import { IndeterminateProgressBar } from './ProgressBar';
import type { AsyncRequestsList } from '../../data/app/AsyncRequestsList';
import { Observer } from 'mobx-react-lite';

/**
 * AppLoadbar
 */
export const AppLoadbar: React.FC<{
    readonly asyncRequests: AsyncRequestsList;
    readonly element?: Element;
    readonly minDuration?: number;
    readonly height?: number;
}> = props => {

    return ReactDOM.createPortal(
        <Observer
            render={() => (
                <IndeterminateProgressBar
                    isLoading={props.asyncRequests.hasPendingRequests}
                    className='uk-position-absolute uk-position-top'
                    minDuration={props.minDuration}
                    height={props.height}
                />
            )}
        />,
        props.element ?? document.body
    )
}